module.exports = __webpack_public_path__ + "img/behindcomp.6241e189.svg";